import { iGame } from '@/entities/game/game.types';
import { from, Subject } from 'rxjs';
import {
  filter,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from 'rxjs/operators';
import { iGameService } from './game.types';
import { iFirestoreGameModel } from '../firestore/firestore.types';


const MIN_SEARCH_LENGTH = 2;
const DEBOUNCE_TIME = 1500;

export class GameService implements iGameService {
  db: iFirestoreGameModel;

  constructor(db: iFirestoreGameModel) {
    this.db = db;
  }

  findById(id: number): Promise<iGame> {
    return this.db.findById(id);
  }

  createSearchObservable() {
    const search$ = new Subject<string>();

    return search$
      .pipe(
        filter((searchKey: string) => !!searchKey),
        filter((searchKey: string) => searchKey.length > MIN_SEARCH_LENGTH),
        debounceTime(DEBOUNCE_TIME),
        distinctUntilChanged(),
        switchMap((searchKey) => from(this.db.search(searchKey))),
        tap((x) => console.log(x)),
      );
  }

  search(query: string, $searchObservable: Subject<string>) {
    $searchObservable
      .next(query);
  }
}
